const users = [
  {
    path: '/clients',
    name: 'clients.list',
    component: () => import('@/views/clients/ClientList.vue'),
    meta: {
      env:['production'],
      pageTitle: 'Clientes',
      breadcrumb: [
        {
          text: 'Listagem de Clientes',
          active: true,
        },
      ],
      roles: [5]
    },
  },
  {
    path: '/clients/:uuid/edit',
    name: 'clients.edit',
    component: () => import('@/views/clients/ClientForm.vue'),
    meta: {
      env:['production'],
      pageTitle: 'Clientes',
      roles: [5],
      breadcrumb: [
        {
          text: 'Listagem de Clientes',
          active: false,
          to: '/clients',
        },
        {
          text: 'Cadastro',
          active: true,
        },
      ],
    },
  },
]

export default users
